import Title from "./components/Title";
import Detail from "./components/Detail";
import {
  calculateBasicPrice,
  calculateTotalPrice,
  calculateDeliveryDate,
  calculateAltDeliveryDate,
  calculateCollectionDate,
  formatDate,
  isValidEmail,
  isValidName,
  getFormData,
  formatDisplayDate,
  isWithin72Hours,
  isDateInRange,
} from "./helper";
import "./App.css";
import { useState, useEffect, useRef } from "react";
import ButtonCard from "./components/ButtonCard";
import ExtrasCard from "./components/ExtrasCard";
import { musicExtras, partyExtras } from "./data";
import ProgressBar from "./components/ProgressBar";
import Address from "./components/Address";
import ReactRecaptcha3 from "react-google-recaptcha3";

function App() {
  var rp =
    process.env.NODE_ENV === "development"
      ? {
          api: {
            nonce: "456911b89e",
            rest_url: "https://silent-disco-hire.local/wp-json/",
            dev: "dev environment",
          },
        }
      : window.reactPress;

  const mediaUrl =
    process.env.NODE_ENV === "development"
      ? "./"
      : "/wp-content/reactpress/apps/sdh-booking-form/public/";
  const script_url =
    "https://script.google.com/macros/s/AKfycbxlUd7zufvX7T8MYYc-VcHpBLFF5laMe3T8TqpFzHK7S06C9pZygCNF0SWy5_bxYYEmZA/exec";

  const formRef = useRef(null);

  const [numHeadphones, setNumHeadphones] = useState();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [deliveryCheck, setDeliveryCheck] = useState(false);
  const [collectionCheck, setCollectionCheck] = useState(false);
  const [recheckAvail, setRecheckAvail] = useState(false);
  const [delivery, setDelivery] = useState(0);
  const [selectedDeliveryDate, setSelectedDeliveryDate] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState("");
  const [altDeliveryDate, setAltDeliveryDate] = useState("");
  const [channels, setChannels] = useState(3);
  const [selectedExtras, setSelectedExtras] = useState({});
  const [collectionDate, setCollectionDate] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [basePrice, setBasePrice] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [uniqueKey, setUniqueKey] = useState(formatDate(Date.now()));
  const [nameValid, setNameValid] = useState(true);
  const [emailValid, setEmailValid] = useState(true);
  const [phoneValid, setPhoneValid] = useState(true);
  const [eventType, setEventType] = useState("");
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [formError, setFormError] = useState(false);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [within72Hours, setWithin72Hours] = useState(false);
  const [formSettings, setFormSettings] = useState({});

  useEffect(() => {
    setTotalPrice(calculateTotalPrice(basePrice, delivery, selectedExtras));
  }, [delivery, selectedExtras, basePrice]);

  // get the unique key from the url if previous enquiry
  useEffect(() => {
    // Get the query parameters from the URL
    const params = new URLSearchParams(window.location.search);
    // Access individual parameters
    const key = params.get("unique");

    const fetchData = async (uniqueKey) => {
      try {
        // Make the GET request to your WordPress REST API endpoint
        const response = await fetch(
          `${rp.api.rest_url}booking-form/v1/get-booking-data/?uniqueKey=${uniqueKey}`
        ).then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          // Parse the JSON in the response
          return response.json();
        });

        const r = JSON.parse(response);
        console.log(r);
        if (r.success) {
          const data = r.data;

          setName(data.name || "");
          setEventDate(data.event_date || "");
          setNumHeadphones(data.num_headphones || 0);
          setEmail(data.email || "");
          setPhone(data.phone || "");
          setBasePrice(parseInt(data.base_price) || 0);
          setDelivery(parseInt(data.delivery) || 0);
          setChannels(parseInt(data.channels) || 2);
          setSelectedExtras(JSON.parse(data.extras) || {});
          if (data.event_date) dateChange(data.event_date);
          setSelectedDeliveryDate(data.delivery_date || "");
          setEventType(data.type_of_event || "");
          setAdditionalInfo(data.additional_info || "");
        } else {
          console.log("Error fetching data:", r.response);
          return false;
        }
      } catch (error) {
        console.error("Error during fetch:", error);
      }
    };

    if (key) {
      setUniqueKey(key);
      fetchData(key);
    }

    const fetchFormSettings = async () => {
      try {
        // Make the GET request to your WordPress REST API endpoint
        const response = await fetch(
          `${rp.api.rest_url}booking-form/v1/get-form-settings/`
        ).then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          // Parse the JSON in the response
          return response.json();
        });

        const r = JSON.parse(response);

        if (r.success) {
          const data = r.data;
          setFormSettings(data);
        } else {
          console.log("Error fetching data:", r.response);
          return false;
        }
      } catch (error) {
        console.error("Error during fetch:", error);
      }
    };

    fetchFormSettings();

    ReactRecaptcha3.init(process.env.REACT_APP_GA_CAPTCHA_SITE).then(
      (status) => {
        return status;
      }
    );
  }, [rp.api.rest_url]);

  const handleNumHeadphones = (e) => {
    const { value } = e.target;
    const bp = calculateBasicPrice(value);
    setNumHeadphones(value);
    setBasePrice(bp);
    setTotalPrice(calculateTotalPrice(bp, delivery, selectedExtras));
  };

  // Handle email change
  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const handlePhone = (e) => {
    const val = e.target.value;
    const validatedValue = val.replace(/[^0-9]/g, "");
    // TO DO Add error for only numbers and min length
    if (validatedValue === "" && val !== "") {
      alert("you must enter number only");
      return;
    }
    setPhone(validatedValue);
  };

  const addExtras = (key, value) => {
    setSelectedExtras({ ...selectedExtras, [key]: value });
  };

  // Handle event date change
  async function dateChange(date) {
    const delDate = await calculateDeliveryDate(date);
    const altDeliveryDate = await calculateAltDeliveryDate(delDate);
    const colDate = await calculateCollectionDate(date);

    setEventDate(date);

    if (isWithin72Hours(date)) {
      setWithin72Hours(true);
      setShowPopup(true);
      setEventDate("");
    }

    if (
      formSettings.limitBookings &&
      isDateInRange(formSettings.startDate, formSettings.endDate, date)
    ) {
      setShowPopup(true);
      setEventDate("");
    }

    setDeliveryDate(delDate);
    setAltDeliveryDate(altDeliveryDate);
    setCollectionDate(colDate);
    setSelectedDeliveryDate(delDate);
  }

  const handleCheckSection = (e, v) => {
    e.preventDefault();

    const checkSection = e.target.getAttribute("data-check");
    const inputElements = document.getElementsByClassName(
      checkSection + "-input"
    );
    let allInputsFilled = true;

    for (let i = 0; i < inputElements.length; i++) {
      const inputValue = inputElements[i].value.trim();

      if (inputValue === "" && inputElements[i].hasAttribute("required")) {
        allInputsFilled = false;
        inputElements[i].classList.add("!border-error");
      } else {
        inputElements[i].classList.remove("!border-error");
      }
    }

    if (!emailValid) return false;

    if (allInputsFilled) {
      document.querySelector(".step1-error").classList.add("hidden");
      const newStep = currentStep < 4 ? currentStep + 1 : currentStep;
      const next = document.getElementById(
        e.target.getAttribute("data-next-section")
      );
      const elementPosition = next.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - 50;

      setCurrentStep(newStep);

      next?.classList.add("step-visible");

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });

      // Save Progress
      const data = _buildDataObject();

      ReactRecaptcha3.getToken({ action: "booking_form" }).then(
        (token) => {
          data.token = token;
          saveData(data);
        },
        (error) => {
          console.log("token error", error);
        }
      );
    } else {
      document.querySelector(".step1-error").classList.remove("hidden");
    }
  };

  const _buildDataObject = (complete = false) => {
    const formData = getFormData(formRef.current);

    const stateData = {
      delivery: delivery,
      delivery_date: selectedDeliveryDate,
      collection_date: collectionDate,
      channels: channels,
      extras: selectedExtras,
      base_price: basePrice,
      total_price: totalPrice,
      unique_key: uniqueKey,
      form_complete: complete,
    };

    return { ...formData, ...stateData };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitting(true);
    // delete_gs();

    const data = _buildDataObject(true);

    ReactRecaptcha3.getToken({ action: "booking_form" }).then(
      (token) => {
        data.token = token;
        saveData(data);
        ReactRecaptcha3.destroy();
      },
      (error) => {
        console.log("token error", error);
        setFormSubmitting(false);
      }
    );
  };

  const saveData = async (data) => {
    try {
      const response = await fetch(
        `${rp.api.rest_url}booking-form/v1/save-booking-data`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-WP-Nonce": rp.api.nonce,
          },
          body: JSON.stringify(data),
        }
      ).then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return response.json();
      });

      const r = JSON.parse(response);

      if (r.success) {
        if (r.redirect_url) {
          window.location.href = r.redirect_url;
        }
        return true;
      } else {
        console.error("Error saving data:", r);
        setFormError(true);
        setFormSubmitting(false);
        return false;
      }
    } catch (error) {
      console.error("Error during fetch:", error);
      setFormError(true);
    }
    return false;
  };

  return (
    <>
      {showPopup && (
        <section id="unavailablePopup" className="text-center">
          <div>
            <a href="/">
              <img
                src={`${mediaUrl}logo.png`}
                alt="Silent Disco Hire Logo"
                className="mx-auto mb-8 max-h-28"
              />
            </a>
            <Title Tag="h2" text="Contact Us" highlighted="for availability." />
            <p className="max-w-4xl mx-auto md:text-2xl font-medium">
              {within72Hours
                ? "As your requested date is within 72 hours, please call us to confirm availability. We should still be able to assist you so don't worry!"
                : "Please contact us regarding availability for your chosen date."}
              <br />
              <br />
              Please call <a href="tel:+4402080047627">0208 004 7627</a> or
              email{" "}
              <a href="mailto:info@silentdiscohire.co.uk">
                info@silentdiscohire.co.uk
              </a>
              <br />
              <br />
              Our friendly team will be happy to assist you.
            </p>
            <button
              className="btn btn-primary !font-sans"
              onClick={(e) => setShowPopup(false)}
            >
              Check another date
            </button>
          </div>
        </section>
      )}

      <div className="App container mx-auto mt-20">
        <a href="/">
          <img
            src={`${mediaUrl}logo.png`}
            alt="Silent Disco Logo"
            className="mx-auto my-8 max-h-28"
          />
        </a>

        <div className="md:flex md:flex-wrap">
          <div className="w-full lg:w-1/12 sm:mb-8 lg:mb-0">
            <ProgressBar currentStep={currentStep} />
          </div>
          <form
            id="bookingForm"
            ref={formRef}
            className="form lg:w-11/12"
            onSubmit={handleSubmit}
            autoComplete="nope"
          >
            <section id="step1" className="form-step step-visible">
              <div className="py-12 lg:w-3/4 mx-auto">
                <Title
                  Tag="h1"
                  text="Instant Quote"
                  highlighted="Check Availability"
                  isH1={true}
                />
                <p className="text-center text-2xl">
                  Fill in the form below to check availability and best price
                </p>

                <div className="text-center my-12">
                  <h2 className="font-sans">
                    How many headphones do you need?
                  </h2>
                  <input
                    name="num_headphones"
                    type="number"
                    onChange={handleNumHeadphones}
                    autoComplete="off"
                    placeholder="0"
                    min={1}
                    max={500}
                    value={numHeadphones}
                    className="step1-input bg-primary-dark py-8 px-12 text-center text-white rounded-lg text-2xl font-bold"
                    required
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <input
                    name="name"
                    type="text"
                    className={`step1-input border border-primary rounded-xl p-4 bg-white shadow-lg ${
                      !nameValid ? "!border-error" : ""
                    }`}
                    placeholder="Full Name"
                    onChange={(e) => setName(e.target.value)}
                    onBlur={(e) => {
                      setNameValid(isValidName(e.target.value));
                    }}
                    value={name}
                    autoComplete="off"
                    required
                  />
                  <input
                    name="event_date"
                    type="date"
                    className="step1-input border border-primary rounded-xl p-4 bg-white shadow-lg"
                    value={eventDate}
                    placeholder="Date of Event"
                    onChange={(e) => dateChange(e.target.value)}
                    onBlur={(e) => dateChange(e.target.value)}
                    autoComplete="off"
                    required
                  />
                  <input
                    name="email"
                    type="email"
                    className={`step1-input border border-primary rounded-xl p-4 bg-white shadow-lg ${
                      !emailValid ? "!border-error" : ""
                    }`}
                    placeholder="Email Address"
                    value={email}
                    onChange={handleEmail}
                    onBlur={(e) => {
                      setEmailValid(isValidEmail(e.target.value));
                    }}
                    autoComplete="off"
                    required
                  />
                  <input
                    name="phone"
                    type="tel"
                    minLength="11"
                    maxLength="14"
                    className={`step1-input border border-primary rounded-xl p-4 bg-white shadow-lg ${
                      !phoneValid ? "!border-error" : ""
                    }`}
                    onChange={handlePhone}
                    onBlur={(e) => {
                      setPhoneValid(e.target.value.length >= 10);
                    }}
                    placeholder="Phone Number"
                    value={phone}
                    autoComplete="off"
                    required
                  />
                </div>
                <p className="text-error text-center mt-4 step1-error hidden">
                  Please fill out all required fields
                </p>
                {!emailValid && (
                  <p className="text-error text-center mt-4">
                    Please enter a valid email address to continue.
                  </p>
                )}
                {!phoneValid && (
                  <p className="text-error text-center mt-4">
                    Please enter a valid phone number to continue.
                  </p>
                )}
                {!nameValid && (
                  <p className="text-error text-center mt-4">
                    Please enter your full name to continue.
                  </p>
                )}
                <button
                  className="btn btn-primary !font-sans !w-full mt-8 !block mx-auto !mr-0"
                  data-next-section="step2"
                  data-check="step1"
                  onClick={handleCheckSection}
                  disabled={
                    !emailValid || !phoneValid || !nameValid ? true : false
                  }
                >
                  Next
                </button>
              </div>
            </section>

            <section id="step2" className="form-step">
              <div className="py-12 lg:w-3/4 mx-auto">
                {numHeadphones > 500 ? (
                  <>
                    <Title
                      Tag="h2"
                      text="Get in touch"
                      highlighted="For a custom quote"
                    />
                    <p className="max-w-4xl mx-auto text-center md:text-2xl">
                      Amount not available to book online please call{" "}
                      <a href="tel:+4402084326151">0208 432 6151</a>.
                    </p>
                  </>
                ) : (
                  <>
                    <Title Tag="h2" text="We have" highlighted="Availability" />
                    <p className="mx-auto text-center md:text-2xl">
                      We have availability for your chosen date. To continue,
                      click 'Next' below to select extras or customize your
                      package. If you need a different date or quantity of
                      headphones, scroll down and click 'Re-check Availability'.
                    </p>
                    <div className="md:px-24">
                      <div className="grid grid-cols-1 md:grid-cols-2 p-8 border rounded-4xl mx-auto shadow-lg md:w-2/3 bg-gradient-to-br from-light to-white">
                        <p className="font-medium text-2xl text-center">
                          Date of event:{" "}
                          <span className="font-bold block">
                            {eventDate && formatDisplayDate(eventDate)}
                          </span>
                        </p>
                        <p className="font-medium text-2xl text-center">
                          Headsets required:{" "}
                          <span className="font-bold block">
                            {numHeadphones && numHeadphones}
                          </span>
                        </p>
                        <div className="md:col-span-2 text-center font-bold text-4xl">
                          <p className="font-sans font-bold text-2xl md:text-4xl">
                            Dry Hire, Basic Price:
                          </p>
                          <span className="py-4 block w-fit mx-auto bg-primary-dark text-center text-white rounded-lg text-2xl font-bold px-24">
                            £{basePrice}
                          </span>
                        </div>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 md:mx-12 gap-4 md:gap-8 mb-4 mt-8">
                        <a
                          href="#step1"
                          className="btn !w-full !block !mr-0 text-center !font-sans"
                        >
                          Back
                        </a>
                        <div
                          className="btn btn-primary !font-sans !w-full !mr-0 text-center"
                          data-next-section="step3"
                          onClick={handleCheckSection}
                        >
                          Next
                        </div>
                      </div>
                    </div>
                  </>
                )}

                <div className="text-center mb-8 md:px-24">
                  <p className="col-span-2 text-center font-bold text-2xl mb-4">
                    Want to check another date or order size?
                  </p>
                  <div
                    className="md:col-span-2 btn !font-sans !px-12 mx-auto !text-lg"
                    onClick={() => setRecheckAvail(!recheckAvail)}
                  >
                    Re-Check Availability
                  </div>
                </div>

                <div
                  className={`grid grid-cols-1 md:grid-cols-2 gap-8 md:mx-12 px-24 ${
                    !recheckAvail ? "h-0 overflow-hidden" : ""
                  }`}
                >
                  <input
                    name="eventDate"
                    type="date"
                    value={eventDate}
                    className="date-picker border border-primary rounded-xl p-4 bg-white shadow-lg"
                    placeholder="Date of Event"
                    onChange={(e) => dateChange(e.target.value)}
                    onBlur={(e) => dateChange(e.target.value)}
                    autoComplete="off"
                  />
                  <input
                    name="num_headphones"
                    type="number"
                    value={numHeadphones}
                    onChange={handleNumHeadphones}
                    autoComplete="off"
                    min={1}
                    max={500}
                    className="border border-primary rounded-xl p-4 bg-white shadow-lg"
                    placeholder="How many headphones do you need?"
                  />
                  <div
                    className="md:col-span-2 btn btn-primary !font-sans !w-full !block !mr-0 text-center"
                    data-next-section="step3"
                    onClick={handleCheckSection}
                  >
                    Next
                  </div>
                </div>
              </div>
            </section>

            <section
              id="step3"
              className={`form-step ${numHeadphones > 500 ? "hidden" : ""}`}
            >
              <div className="py-12 lg:w-3/4 xl:w-2/3 mx-auto">
                <Title Tag="h2" text="Customise" highlighted="Your Package" />
                <p className="max-w-4xl mx-auto text-center md:text-2xl">
                  We have some fantastic extras and additions to our hire
                  packages, View and choose the options below to ensure you have
                  everything you require for your booking.
                </p>
                <div className="text-center my-12 lg:my-24 text-4xl">
                  <p className="text-4xl">
                    Total Price:
                    <span className="bg-primary py-4 w-fit bg-primary-dark text-center text-white rounded-lg text-2xl font-bold px-8 ml-4">
                      £{totalPrice}
                    </span>
                  </p>
                </div>

                <h3 className="text-center font-sans mb-8">Delivery</h3>
                <div className="md:w-3/4 mx-auto grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-12 mb-16">
                  <ButtonCard
                    title="Standard"
                    text="Receive your order between"
                    boldText="9am - 5pm"
                    btnText="Free"
                    selected={delivery === 0 ? true : false}
                    onButtonClick={() => setDelivery(0)}
                  />
                  <ButtonCard
                    title="Premium"
                    text="Receive your order before"
                    boldText="12pm"
                    btnText="£15"
                    selected={delivery === 15 ? true : false}
                    onButtonClick={() => setDelivery(15)}
                  />
                </div>

                <h3 className="text-center font-sans mb-8">
                  How Many Channels would you like?
                  <br />
                  (We don't charge extra!)
                </h3>
                <div className="md:w-3/4 mx-auto grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-12 mb-16">
                  <ButtonCard
                    title="Two Channel System"
                    selected={channels === 2 ? true : false}
                    onButtonClick={() => setChannels(2)}
                  />
                  <ButtonCard
                    title="Three Channel System"
                    selected={channels === 3 ? true : false}
                    onButtonClick={() => setChannels(3)}
                  />
                </div>

                <h3 className="text-center font-sans">
                  How do you want to play music?
                </h3>
                <p className="text-center">
                  If you are using your own devices you may need Apple of USB C
                  adaptors.{" "}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-12 mb-16">
                  {musicExtras.map((item, i) => {
                    return (
                      <ExtrasCard
                        key={`musicExtras${i}`}
                        cardContent={item}
                        selected={selectedExtras.hasOwnProperty(item.id)}
                        onSelect={addExtras}
                        inputValue={selectedExtras[item.id]?.value}
                        channels={channels}
                      />
                    );
                  })}
                </div>

                <h3 className="text-center font-sans mb-8">
                  Extras to make your party stand out
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-12 mb-4">
                  {partyExtras.map((item, i) => {
                    return (
                      <ExtrasCard
                        key={`partyExtras${i}`}
                        cardContent={item}
                        onSelect={addExtras}
                        selected={selectedExtras.hasOwnProperty(item.id)}
                        inputValue={selectedExtras[item.id]?.value}
                      />
                    );
                  })}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 md:mx-12 gap-4 md:gap-8 mb-8">
                  <a
                    href="#step2"
                    className="btn !font-sans !w-full md:mt-8 !block !mr-0 text-center"
                  >
                    Back
                  </a>
                  <div
                    className="btn btn-primary !font-sans !w-full md:mt-8 text-center !mr-0"
                    data-next-section="step4"
                    onClick={handleCheckSection}
                  >
                    Next
                  </div>
                </div>
              </div>
            </section>

            <section
              id="step4"
              className={`form-step ${numHeadphones > 500 ? "hidden" : ""}`}
            >
              <div className="py-12 lg:w-3/4 xl:w-2/3 mx-auto">
                <Title Tag="h2" text="Delivery" highlighted="Details" />
                <p className="max-w-4xl mx-auto text-center md:text-2xl font-medium">
                  We deliver your hire the day before your event and collect the
                  day after. If your booking is during the weekend (Sat/Sun),
                  delivery will be the Friday and collection on Monday. Our
                  courier will text you with a 1-hour time slot for both
                  delivery and collection. You are also able to specify
                  different addresses below to make it as easy and flexible as
                  possible.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-20 mb-12 md:mb-24">
                  <div className="text-center">
                    <h3 className="font-sans">Delivery Date</h3>
                    <p>
                      Your silent disco hire will arrive by DPD <br />
                      <strong>before 12pm</strong>
                    </p>
                    <div className="flex flex-wrap gap-4">
                      <span
                        className={` ${
                          selectedDeliveryDate === altDeliveryDate &&
                          "bg-primary"
                        } hover:cursor-pointer shadow-lg border border-primary rounded-2xl px-8 py-4 mx-auto w-fit font-bold text-2xl`}
                        onClick={() => setSelectedDeliveryDate(altDeliveryDate)}
                      >
                        {altDeliveryDate}
                      </span>
                      <span
                        className={` ${
                          selectedDeliveryDate === deliveryDate && "bg-primary"
                        } hover:cursor-pointer shadow-lg border border-primary rounded-2xl px-8 py-4 mx-auto w-fit font-bold text-2xl`}
                        onClick={() => setSelectedDeliveryDate(deliveryDate)}
                      >
                        {deliveryDate ? deliveryDate : "00/00/0000"}
                      </span>
                      <input
                        type="hidden"
                        name="delivery_date"
                        value={selectedDeliveryDate}
                      />
                    </div>
                  </div>
                  <div className="text-center">
                    <h3 className="font-sans">Collection Date</h3>
                    <p>
                      Your silent disco hire will be collected <br />
                      <strong>between 9am-5pm</strong>
                    </p>
                    <div className="bg-primary rounded-2xl px-8 py-4 mx-auto w-fit font-bold text-2xl shadow-lg">
                      {collectionDate ? collectionDate : "00/00/0000"}
                    </div>
                  </div>
                </div>

                <h3 className="text-center font-sans">Your Booking Summary</h3>
                <div className="bg-gradient-to-br from-light to-white rounded-3xl border border-dark py-12 px-8 md:px-20 md:mx-12 mb-12">
                  <p className="font-bold text-4xl text-center">Total price:</p>
                  <span className="bg-primary-dark rounded-lg px-8 py-4 block w-fit mx-auto my-12 font-bold text-4xl text-white">
                    £{totalPrice}
                  </span>

                  <p className="font-bold text-4xl text-center">
                    Your Details:
                  </p>
                  <Detail label="Name:" value={name} />
                  <Detail label="Mobile Number:" value={phone} />
                  <Detail label="Email:" value={email} />

                  <p className="font-bold text-4xl text-center mt-12">
                    Order Details:
                  </p>
                  <Detail
                    label="Date of Event:"
                    value={formatDisplayDate(eventDate)}
                  />
                  <Detail label="Delivery Date:" value={selectedDeliveryDate} />
                  <Detail label="Collection Date:" value={collectionDate} />
                  <Detail label="No of Headsets:" value={numHeadphones} />
                  <Detail label="Basic price:" value={`£${basePrice}`} />
                  <Detail label="Number of channels:" value={channels} />
                  <Detail
                    label="Delivery:"
                    value={delivery === 0 ? "Free" : `£${delivery}`}
                  />

                  {Object.entries(selectedExtras).map(([key, value]) => {
                    return (
                      value.value > 0 && (
                        <Detail
                          key={key}
                          label={`${value.title}:`}
                          value={value.label}
                        />
                      )
                    );
                  })}
                </div>

                <h4 className="mb-4 font-sans">Billing Address & Postcode</h4>
                <Address type="billing" />

                <div>
                  <input
                    id="deliveryCheck"
                    type="checkbox"
                    name="delivery_address_check"
                    onChange={() => setDeliveryCheck((prevState) => !prevState)}
                  />
                  <label
                    htmlFor="deliveryCheck"
                    className="ml-2 inline-block mb-4"
                  >
                    Use a different address for <strong>Delivery</strong>
                  </label>
                </div>

                {deliveryCheck ? (
                  <>
                    <h4 className="mb-4 font-sans">
                      Delivery Address & Postcode
                    </h4>

                    <Address type="delivery" />
                  </>
                ) : (
                  ""
                )}

                <div>
                  <input
                    id="collectionCheck"
                    type="checkbox"
                    name="collection_address_check"
                    onChange={() =>
                      setCollectionCheck((prevState) => !prevState)
                    }
                  />
                  <label
                    htmlFor="collectionCheck"
                    className="ml-2 inline-block mb-4"
                  >
                    Use a different address for <strong>Collection</strong>
                  </label>
                </div>

                {collectionCheck ? (
                  <>
                    <h4 className="mb-4 font-sans">
                      Collection Address & Postcode
                    </h4>

                    <Address type="collection" />
                  </>
                ) : (
                  ""
                )}

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <input
                    name="type_of_event"
                    type="text"
                    value={eventType}
                    onChange={(e) => setEventType(e.target.value)}
                    className="border border-primary rounded-xl p-4 bg-white shadow-lg"
                    placeholder="Type of Event"
                    autoComplete="off"
                  />
                  <input
                    name="additional_info"
                    type="text"
                    value={additionalInfo}
                    onChange={(e) => setAdditionalInfo(e.target.value)}
                    className="border border-primary rounded-xl p-4 bg-white shadow-lg"
                    placeholder="Anything else we should know?"
                    autoComplete="off"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 md:mx-12 gap-4 md:gap-8">
                  <a
                    href="#step3"
                    className="btn !font-sans !w-full mt-8 !block !mr-0 text-center"
                  >
                    Back
                  </a>
                  <button
                    type="submit"
                    className={`btn btn-primary !font-sans !w-full md:mt-8 !block !mr-0 ${
                      formSubmitting ? "opacity-10" : ""
                    }`}
                    disabled={formSubmitting}
                  >
                    {formSubmitting
                      ? "Confirming your booking..."
                      : "Confirm your booking"}
                  </button>
                </div>
                {formError && (
                  <p className="text-error text-center mt-4">
                    Sorry we are unable to process your enquiry at this time.
                  </p>
                )}
              </div>
            </section>
          </form>
        </div>
      </div>
    </>
  );
}

export default App;
